"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFundsOriginCommunityInvestment = void 0;
exports.EFundsOriginCommunityInvestment = {
    goods_before_marriage: "goods_before_marriage",
    donation: "donation",
    succession: "succession",
    other: "other",
};
